import informationService from '../../services/system';

const dataSource = async (data, instance, setInfo) => {
    let arrayTables = [];
    let arrayResponse = [];
    for (let f = 0; f < data.length; f++) {
        for (let h = 0; h < data[f].boxes.length; h++) {
            for (let u = 0; u < data[f].boxes[h].fields.length; u++) {

                if (data[f].boxes[h].fields[u].sourceSelect !== null) {
                    let existe = false;
                    for (let y = 0; y < arrayTables.length; y++) {
                        if (data[f].boxes[h].fields[u].sourceSelect === arrayTables[y].table.split('.')[1]) {
                            existe = true;
                        }
                    }

                    if (existe === false) {
                        let doc = [];
                        if (data[f].boxes[h].fields[u].sourceSelectDoc !== null) {
                            for (let n = 0; n < data[f].boxes[h].fields[u].sourceSelectDoc.length; n++) {
                                doc.push(data[f].boxes[h].fields[u].sourceSelectDoc[n]);
                            }
                        }
                        let selectFilters = [];
                        if (data[f].boxes[h].fields[u].dataSource !== null) {
                            for (let p1 = 0; p1 < data[f].boxes.length; p1++) {
                                for (let a1 = 0; a1 < data[f].boxes[p1].fields.length; a1++) {
                                    if (Number(data[f].boxes[p1].fields[a1].id) === Number(data[f].boxes[h].fields[u].dataSource)) {
                                        selectFilters.push(data[f].boxes[p1].fields[a1].idFieldTable)
                                    }
                                }
                            }
                        }
                        if (data[f].boxes[h].fields[u].sourceSelect === 'zip') {
                            selectFilters.push('stateId');
                        }
                        arrayTables.push({
                            table: `${instance}.${data[f].boxes[h].fields[u].sourceSelect}`,
                            doc: [],
                            entityDocId: data[f].entityDocId,
                            selectFilters: selectFilters
                        })
                    }
                }

                if (data[f].boxes[h].fields[u].group !== null) {

                    for (let t = 0; t < data[f].boxes[h].fields[u].group.length; t++) {

                        for (let k = 0; k < data[f].boxes[h].fields[u].group[t].fields.length; k++) {
                            if (data[f].boxes[h].fields[u].group[t].fields[k].sourceSelect !== null) {
                                let existe = false;
                                for (let y = 0; y < arrayTables.length; y++) {
                                    if (data[f].boxes[h].fields[u].group[t].fields[k].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                        existe = true;
                                    }
                                }
                                if (existe === false) {
                                    let doc = [];
                                    if (data[f].boxes[h].fields[u].group[t].fields[k].sourceSelectDoc !== null) {
                                        for (let n = 0; n < data[f].boxes[h].fields[u].group[t].fields[k].sourceSelectDoc.length; n++) {
                                            doc.push(data[f].boxes[h].fields[u].group[t].fields[k].sourceSelectDoc[n]);
                                        }
                                    }
                                    let selectFilters = [];
                                    if (data[f].boxes[h].fields[u].group[t].fields[k].dataSource !== null) {
                                        for (let p1 = 0; p1 < data[f].boxes.length; p1++) {
                                            for (let a1 = 0; a1 < data[f].boxes[p1].fields.length; a1++) {
                                                if (Number(data[f].boxes[p1].fields[a1].id) === Number(data[f].boxes[h].fields[u].group[t].fields[k].dataSource)) {
                                                    selectFilters.push(data[f].boxes[p1].fields[a1].idFieldTable)
                                                }
                                                if (data[f].boxes[p1].fields[a1].group !== null) {
                                                    for (let b1 = 0; b1 < data[f].boxes[p1].fields[a1].group.length; b1++) {
                                                        for (let c1 = 0; c1 < data[f].boxes[h].fields[u].group[b1].fields.length; c1++) {
                                                            if (Number(data[f].boxes[h].fields[u].group[b1].fields[c1].id) === Number(data[f].boxes[h].fields[u].group[t].fields[k].dataSource)) {
                                                                selectFilters.push(data[f].boxes[h].fields[u].group[b1].fields[c1].idFieldTable)
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if (data[f].boxes[h].fields[u].group[t].fields[k].sourceSelect === 'zip') {
                                        selectFilters.push('stateId');
                                    }
                                    arrayTables.push({
                                        table: `${instance}.${data[f].boxes[h].fields[u].group[t].fields[k].sourceSelect}`,
                                        doc: [],
                                        entityDocId: data[f].entityDocId,
                                        selectFilters: selectFilters
                                    })
                                }
                            }
                        }


                        for (let m = 0; m < data[f].boxes[h].fields[u].group[t].fields.length; m++) {
                            if (data[f].boxes[h].fields[u].group[t].fields[m].subGroup !== null) {
                                for (let k = 0; k < data[f].boxes[h].fields[u].group[t].fields[m].subGroup.length; k++) {

                                    for (let q = 0; q < data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields.length; q++) {


                                        if (data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelect !== null) {
                                            let existe = false;
                                            for (let y = 0; y < arrayTables.length; y++) {
                                                if (data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                                    existe = true;
                                                }
                                            }
                                            if (existe === false) {
                                                let doc = [];
                                                if (data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelectDoc !== null) {
                                                    for (let n = 0; n < data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelectDoc.length; n++) {
                                                        doc.push(data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelectDoc[n]);
                                                    }
                                                }

                                                let selectFilters = [];
                                                if (data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelect === 'zip') {
                                                    selectFilters.push('stateId');
                                                }
                                                arrayTables.push({
                                                    table: `${instance}.${data[f].boxes[h].fields[u].group[t].fields[m].subGroup[k].fields[q].sourceSelect}`,
                                                    doc: [],
                                                    entityDocId: data[f].entityDocId,
                                                    selectFilters: selectFilters

                                                })
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    const responseViewTables = await informationService.viewTables();

    if (arrayTables.length > 0) {
        for (let r = 0; r < responseViewTables.data.length; r++) {
            for (let y = 0; y < arrayTables.length; y++) {
                let tableFlag = arrayTables[y].table.split('.');
                if (tableFlag[1] === responseViewTables.data[r].name) {
                    arrayTables[y].table = `wbSys.${tableFlag[1]}`;
                }
            }
        }
        let arrayInitial = [];
        for (let r = 0; r < arrayTables.length; r++) {
            if (Number(arrayTables[r].entityDocId) === 1) {
                //arrayInitial.push(arrayTables[r])
                arrayTables.push({
                    table: arrayTables[r].table,
                    doc: [],
                    selectFilters: [],
                    whereFilters: []
                })
            }
        }

        const responseSourceField = await informationService.findSourceField(arrayInitial);
        for (let i = 0; i < responseSourceField.data.length; i++) {
            if (responseSourceField.data[i].isInactive === "0") {
                arrayResponse.push(responseSourceField.data[i]);
            }
        }

        setInfo(arrayResponse);

        let arrayFlag = [];
        for (let r = 0; r < arrayTables.length; r++) {
            if (Number(arrayTables[r].entityDocId) !== 1) {
                //arrayFlag.push(arrayTables[r])
                arrayFlag.push({
                    table: arrayTables[r].table,
                    doc: [],
                    selectFilters: [],
                    whereFilters: []
                })
            }

        }

        const size = 3; // Tamaño de cada partición (5 elementos)
        const promises = []; // Array para almacenar las promesas de las llamadas a la API

        // Particiona el array en subarreglos de tamaño 5
        const partitions = partitionArray(arrayFlag, size);

        // Itera sobre cada partición y realiza llamadas a la API
        partitions.forEach(partition => {
            // Verifica si la partición contiene elementos con entityDocId distinto de 1
            if (partition.some(item => Number(item.entityDocId) !== 1)) {
                // Realiza una llamada a la API con la partición actual
                const apiPromise = informationService.findSourceField(partition);
                promises.push(apiPromise); // Agregar la promesa a la lista
            }
        });

        // Usar Promise.all() para esperar a que todas las promesas se resuelvan
        return Promise.all(promises)
            .then(responses => {
                // `responses` es un array con las respuestas de todas las llamadas a la API
                //return responses; // Devuelve las respuestas de la API a la función principal

                for (let d = 0; d < responses.length; d++) {
                    for (let i = 0; i < responses[d].data.length; i++) {
                        if (responses[d].data[i].isInactive === "0") {
                            arrayResponse.push(responses[d].data[i]);
                        }
                    }
                }
                setInfo(arrayResponse);
                return arrayResponse;
            })
            .catch(error => {
                console.error('Error calling API:', error);
            });

        //return arrayResponse;
    }
}

function partitionArray(array, size) {
    const partitions = [];
    for (let i = 0; i < array.length; i += size) {
        const partition = array.slice(i, i + size);
        partitions.push(partition);
    }
    return partitions;
}

export default dataSource;